<h2 class="mt-3">{{cardConfiguration.title}}</h2>
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <label class="disabled" for="country">{{'CardServiceContacts.Country' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.countryCode" name="country" #country="ngModel" readonly disabled
              [clearRelated]="{model : this.cardData , propsToReset : ['mobileNumber','landlineNumber']} "
              [dropdownTitle]="{value : cardData.countryCode, dimensions :  countries }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of countries" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="country"></validation-message>
    </div>
  </div>
  <div class="col-sm-8">
    <div class="form-group disabled">
      <label for="morada">{{'CardServiceContacts.Address' | translate}}</label>
      <input id="morada" class="form-control" type="text" [(ngModel)]="cardData.address" name="morada" #morada="ngModel" maxlength="80" readonly>
      <validation-message [control]="morada"></validation-message>
    </div>
    
  </div>
</div>
<div class="row">
  <!--Postal Code might change based on format of data received-->
  <div class="col-sm-4" *ngIf="cardData.countryCode=='PT'">
    <div class="form-group">
      <label for="PostalCode" class="disabled">{{'CardServiceContacts.PostalCode' | translate}}</label>
      <div class="form-row">
        <div class="col-sm-6">
          <input class="form-control" type="text" numeric="4" placeholder="0000" [(ngModel)]="cardData.postalCodeFirst" name="postalCodeFirst" #postalCodeFirst="ngModel"  readonly>
          <validation-message [control]="postalCodeFirst"></validation-message>
        </div>
        <div class="col-sm-6">
          <input class="form-control" type="text" numeric="3" placeholder="000" [(ngModel)]="cardData.postalCodeLast" name="postalCodeLast" #postalCodeLast="ngModel" pattern="\d*"  readonly>
          <validation-message [control]="postalCodeLast"></validation-message>
        </div>
      </div>
    </div>

  </div>
  <div class="col-sm-4" *ngIf="cardData.countryCode!='PT'">
    <div class="form-group">
      <label class="disabled" for="Postal Code">{{'CardServiceContacts.PostalCode' | translate}}</label>
      <input class="form-control" type="text"
             placeholder="{{'Placeholders.Generic.ForeignPostalCode' | translate}}"
             [(ngModel)]="cardData.postalCodeFull" name="postalCodeFull" #postalCodeFull="ngModel"  readonly maxlength="20">
      <validation-message [control]="postalCodeFull"></validation-message>
    </div>

  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label class="disabled" for="Postal Designation">{{'CardServiceContacts.PostalDesignation' | translate}}</label>
      <input class="form-control" type="text" [(ngModel)]="cardData.postalDesignation" name="postalDesignation" #postalDesignation="ngModel" readonly>
      <validation-message [control]="postalDesignation"></validation-message>
    </div>

  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label class="disabled" for="city">{{'CardServiceContacts.City' | translate}}</label>
      <input class="form-control" type="text" [(ngModel)]="cardData.city" name="city" #city="ngModel" readonly>
      <validation-message [control]="city"></validation-message>
    </div>

  </div>
</div>
<!--Postal Code might change based on format of data received-->
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <label class="disabled" for="LandlineNumber">{{'CardServiceContacts.LandlineNumber' | translate}}</label>
      <input class="form-control" type="text" [numeric]="cardData.countryCode=='PT' ? '14' : '30'"  [(ngModel)]="cardData.landlineNumber" name="landlineNumber" #landlineNumber="ngModel" readonly>
      <validation-message [control]="landlineNumber"></validation-message>
    </div>
    
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="MobileNumber">{{'CardServiceContacts.MobileNumber' | translate}}</label>
      <input class="form-control" type="text" [numeric]="cardData.countryCode=='PT' ? '14' : '30'" placeholder="{{'Placeholders.Generic.MobileNumber' | translate}}" [(ngModel)]="cardData.mobileNumber" name="mobileNumber" #mobileNumber="ngModel" readonly>
      <validation-message [control]="mobileNumber"></validation-message>
    </div>
    
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="Email" class="disabled"><i>{{'CardServiceContacts.Email' | translate}}</i></label>
      <input class="form-control" type="email" placeholder="{{'Placeholders.Generic.Email' | translate}}" [(ngModel)]="cardData.email" name="email" #email="ngModel" email maxlength="60" pattern="^.+@.+\..+$" disabled>
      <validation-message [control]="email"></validation-message>
    </div>
    
  </div>
</div>

<div class="form-group text-secondary ft-sz-12">
  <label style="display:block">
    Alguns campos não são editáveis. Caso verifique dados incorretos, deve solicitar a sua atualização por e-mail com o assunto “atualização dados entidades”.
  </label>
</div>
<!--<pre>{{cardData | json}}</pre>-->
